import { Component, Input, EventEmitter, OnInit } from '@angular/core';
import { ChartDetails } from '../../../models/chart-details';
import { MetricCard } from '../../../models/metric-card';
import { UserService } from '../../../services/user.service';
import { Settings } from 'src/app/services/settings';
import { HomeService } from '../../../services/home.service';
import {AgenciesService} from "../../../services/agencies.service";
import {DataRecord} from "../../requests/commands/req-status/req-status.component";
import {DashboardService} from "../../../services/dashboard.service";
import {RendererHelper} from "./renderer-helper";
import {get_settings} from "../../../app.module";

@Component( {
    selector: 'app-home-renderer',
    templateUrl: './home-renderer.component.html',
    styleUrls: ['./home-renderer.component.css']
} )
export class HomeRendererComponent implements OnInit {

    @Input() _totalMetricCardArr: Array<MetricCard>;
    @Input() _totalChartArr: Array<ChartDetails>;

    public chartMetaData: any;
    public metricCardArr: Array<MetricCard>;
    public chartArr: Array<ChartDetails>;

    public selectedMetricCards: Array<number>;
    public selectedCharts: Array<number>;
    public siteIdx = 0;
    public panelOpen: boolean | null = false;

    public sitesList: any[];
    public selectedSite: any;
    public activeMetricCardList: any[];
    public activeChartList: any[];

    public hasAgencySelection: boolean = false;
     public hastimeFrameSelection: boolean = false;
    /** agencies list **/
    public agenciesList: any;
    public selectedAgency: any;

    /** timeframe **/
    public timeframeList: any;
    public selectedTimeframe: any
    public startDate: any;
    public endDate: any;
    public prevStartDate: any;
    public prevEndDate: any;
    public agencyName: string;
    public helper: RendererHelper;
    private refreshEvent: EventEmitter<boolean> = new EventEmitter();

    @Input() set totalMetricCardArr( value: Array<MetricCard> ) {
        this._totalMetricCardArr = value;
        this.homeResetHandler( null );
    }

    get totalMetricCardArr(): Array<MetricCard> {
        return this._totalMetricCardArr;
    }

    @Input() set totalChartArr( value: Array<ChartDetails> ) {
        this._totalChartArr = value;
        this.homeResetHandler( null );
    }

    get totalChartArr(): Array<ChartDetails> {
        return this._totalChartArr;
    }

    constructor(private userService: UserService,
                public agencyService: AgenciesService,
                public dashboardService: DashboardService) {

        this.selectedSite = null;
        this.siteIdx = 0;
        this.hasAgencySelection = Settings.getInstance().hasPrivilege('DASHBOARD_AGENCY_SEL', "EXECUTE");
        this.hastimeFrameSelection = Settings.getInstance().hasPrivilege('DASHBOARD_TIMEFRAME_SEL', "EXECUTE");
        this.helper = new RendererHelper();

        this.setTimeFrames();

        if(this.hasAgencySelection === true) {
            this.queryAgencies();
        }
        else {
            this.selectedAgency = Settings.getInstance().loggedInUser.agencyId;
            this.agencyService.getAgencyById(this.selectedAgency).subscribe(
                (result) => {
                    this.agencyName = result.agencyName;
                },
                (error) => {
                    /** nothing **/
                });
        }
    }

    ngOnInit() {

        if (Settings.getInstance().loggedInUser.dashboard_settings === null || Settings.getInstance().loggedInUser.dashboard_settings === undefined) {
			this.activeMetricCardList = null;
			this.activeChartList = null;
		}
        else {

            const dashboardSetup = JSON.parse(Settings.getInstance().loggedInUser.dashboard_settings);
	    	const activeMetricCards = dashboardSetup.active_home_metric_cards;
	    	const activeCharts = dashboardSetup.active_home_charts;

	    	if (activeMetricCards === null || activeMetricCards === undefined) {
	    		this.activeMetricCardList = null;
	    	} else {
	    		this.activeMetricCardList = activeMetricCards.split(',');
	    	}
	    	if (activeCharts === null || activeCharts === undefined) {
	    		this.activeChartList = null;
	    	} else {
	    		this.activeChartList = activeCharts.split(',');
	    	}
    	}

        this.reloadRecords();
    }
    public setTimeFrames(): void {
        this.timeframeList= [];
        this.timeframeList.push(new DataRecord(1, "This Day"));
        this.timeframeList.push(new DataRecord(7, "This Week"));
        this.timeframeList.push(new DataRecord(30, "This Month"));
        this.timeframeList.push(new DataRecord(1040, "Last 6 Months"));

        this.selectedTimeframe = this.timeframeList[1].id;     // this week.
        this.setDates();
    }
    public queryAgencies(): void {

        this.agenciesList = [];
        this.selectedAgency = 0;
        this.agenciesList.push(new DataRecord(0, 'All Agencies'));
        this.agencyService.getAllAgencies().subscribe(
            (results) => {
                /** quick sort by the agency name **/
                const newResults = results.sort((a, b) =>
                    a['agencyName'].localeCompare(b['agencyName']));

                for(const rec of newResults) {
                    const element = new DataRecord(rec.id, rec.agencyName);
                    this.agenciesList.push(element);
                }

            },
            (error) => {
                Settings.getInstance().handleError(error, 'fetching Agencies')
            }
        )
    }

    public onAgencyChange(event): void {
        this.reloadRecords();
    }
    public onTimeframeChange(event): void {

        this.selectedTimeframe = event;
        this.setDates();
        this.reloadRecords();
    }
    public setDates(): void {

        this.helper.calculateDatePair(this.selectedTimeframe);
        this.startDate = this.helper.startDate;
        this.endDate = this.helper.endDate;
        this.prevStartDate = this.helper.prevStartDate;
        this.prevEndDate = this.helper.prevEndDate;
    }
    public reloadRecords(): void {
        this.queryMetricCardDataByAgency();

    }
    public resetCharts(): void {
        // throw an event to be caught in Card.component.ts.
        this.refreshEvent.emit(true);
    }
    public queryMetricCardDataByAgency(): void {

        this.dashboardService.getMetricCardDataByAgency(this.selectedAgency, this.startDate, this.endDate, this.prevStartDate, this.prevEndDate).subscribe(
        (results) => {
               this.setResults(results);
            },
        (error) => {
            Settings.getInstance().handleError(error, 'fetching data for metric cards');
        });

    }
   public setResults(values: any): void {

        for(let i = 0; i < this.metricCardArr.length; i++) {

            try {
                this.metricCardArr[i].current_result = 0;
                this.metricCardArr[i].previous_result = 0;
                let searchCode = this.metricCardArr[i].code;
                let curr_result = values.find(s => s.id === Number(searchCode));
                this.metricCardArr[i].current_result = curr_result.current;
                this.metricCardArr[i].previous_result = curr_result.previous;

            } catch(error) {
                // nothing.
            }
        }
    }
   public homeResetHandler( event ) {
        this.selectedMetricCards = new Array<number>();
        this.selectedCharts = new Array<number>();
        if ( this.totalMetricCardArr != null ) {
            this.totalMetricCardArr.forEach(( item: MetricCard ) => {
            	if (event == null) {
            		if (this.activeMetricCardList == null || this.activeMetricCardList.indexOf( String(item.id) ) != -1) {
            			this.selectedMetricCards.push( item.id );
            		}
            	} else {
            		this.selectedMetricCards.push( item.id );
            	}
                
            } );
        }
        if ( this.totalChartArr != null ) {
            this.totalChartArr.forEach(( item: ChartDetails ) => {
            	if (event == null) {
            		if (this.activeChartList == null || this.activeChartList.indexOf( String(item.id) ) !== -1) {
            			this.selectedCharts.push( item.id );
            		}
            	} else {
                	this.selectedCharts.push( item.id );
            	}
            } );
        }
        this.homeApplyHandler( event );
    }
   public homeCancelHandler( event ) {

   }
   public homeApplyHandler( event ) {
        this.metricCardArr = new Array<MetricCard>();
        if ( this.totalMetricCardArr != null ) {
            this.totalMetricCardArr.forEach(( item: MetricCard ) => {
                if (this.selectedMetricCards.indexOf( item.id ) !== -1 ) {
                    this.metricCardArr.push( item );
                }
            } );
        }
        this.chartArr = new Array<ChartDetails>();
        if ( this.totalChartArr != null ) {
            this.totalChartArr.forEach(( item: ChartDetails ) => {
                if (this.selectedCharts.indexOf( item.id ) !== -1 ) {
                    this.chartArr.push( item );
                }
            } );
        }
        if (event != null) {
        	const dashboardSetup = {active_home_metric_cards: this.selectedMetricCards.toString(), active_home_charts: this.selectedCharts.toString()};
        	Settings.getInstance().loggedInUser.dashboard_settings = JSON.stringify(dashboardSetup);
        	this.userService.updateUserDashboardSetup(Settings.getInstance().loggedInUser, dashboardSetup).subscribe(
        			data => {
        				
        			},
        			(error) => {
        				Settings.getInstance().handleError(error);
        			});
        }
    }
}
